function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m11.188 5.205 9.847 106.076L64 122.795l42.965-11.514 9.847-106.076H64Z",
    style: {
      fill: "#255da9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.568 26.557h65.94l-1.219 14.078-30.213 12.27h29.15L90.73 93.29l-26.795 7.879-26.797-7.879-1.965-19.97h13.521l1.313 10.25 13.928 3.677 14.705-4.469 1.058-16.549H34.473l-1.264-12.847L64.98 40.48H31.94Z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgIcon;